/*
 * Generated from Helvetica-Bold.afm. Do not edit directly.
 * The source AFM metrics were converted to JavaScript; this is a modification.
 * Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.
 *
 * This file and the 14 PostScript(R) AFM files it accompanies may be used, copied, and distributed for any purpose and without charge, with or without modification, provided that all copyright notices are retained; that the AFM files are not distributed without this file; that all modifications to this file or any of the AFM files are prominently noted in the modified file(s); and that this paragraph is not modified. Adobe Systems has no responsibility or obligation to support the use of the AFM files.
 */
import glyphNames from './standardGlyphNames.js';
export default {
  name: 'Helvetica-Bold',
  bbox: [-170, -228, 1003, 962],
  ascender: 718,
  descender: -207,
  xHeight: 532,
  capHeight: 718,
  glyphNames,
  glyphWidths: [
    278, 333, 474, 556, 556, 889, 722, 238, 333, 333, 389, 584, 278, 333, 278,
    278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 333, 333, 584, 584,
    584, 611, 975, 722, 722, 722, 722, 667, 611, 778, 722, 278, 556, 722, 611,
    833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 333,
    278, 333, 584, 556, 333, 556, 611, 556, 611, 556, 333, 611, 611, 278, 278,
    556, 278, 889, 611, 611, 611, 611, 389, 556, 333, 611, 556, 778, 556, 556,
    500, 389, 280, 389, 584, 556, 278, 556, 500, 1000, 556, 556, 333, 1000, 667,
    333, 1000, 611, 278, 278, 500, 500, 350, 556, 1000, 333, 1000, 556, 333,
    944, 500, 556, 333, 556, 556, 556, 556, 280, 556, 333, 737, 370, 556, 584,
    737, 333, 400, 584, 333, 333, 333, 611, 556, 278, 333, 333, 365, 556, 834,
    834, 834, 611, 722, 722, 722, 722, 722, 722, 1000, 722, 667, 667, 667, 667,
    278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722,
    722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 556, 556, 556,
    556, 556, 278, 278, 278, 278, 611, 611, 611, 611, 611, 611, 611, 584, 611,
    611, 611, 611, 611, 556, 611,
  ],
  kernPairs: [
    -140,
    [9569, 2],
    -120,
    [57, 124, 2508, 2, 428, 2, 6396, 124, 691, 2, 859, 429, 2],
    -110,
    [
      7152, 124, 2238, 2774, 119, 1, 1, 1, 1, 1, 20325, 124, 91, 124, 91, 124,
      91, 124, 91, 124, 91, 124, 5012, 119, 1, 1, 1, 1, 1,
    ],
    -100,
    [
      52, 8130, 2, 2169, 119, 1, 1, 1, 1, 1, 1790, 2, 65, 6, 117, 1, 1, 1, 1, 2,
      1, 1, 1, 1, 26460, 2, 65, 6, 117, 1, 1, 1, 1, 2, 1, 1, 1, 1,
    ],
    -90,
    [
      7147, 2365, 1701, 52, 67, 1, 1, 1, 1, 1, 52, 1, 1, 1, 297, 123, 1, 1, 1,
      1, 2, 502, 119, 1, 1, 1, 1, 1, 20288, 215, 215, 215, 215, 215, 5173, 119,
      1, 1, 1, 1, 1,
    ],
    -80,
    [
      54, 1, 55, 7039, 1054, 119, 1, 1, 1, 1, 1, 1188, 1677, 2, 51, 14, 3, 102,
      1, 1, 1, 1, 1, 13, 1, 1, 1, 1, 2, 235, 20, 119, 1, 1, 1, 1, 1, 70, 2, 485,
      123, 1, 1, 1, 6052, 2, 643, 2, 4286, 68, 362, 2162, 2, 6705, 215, 215,
      215, 215, 215, 5175, 123, 1, 1, 1, 6697, 2,
    ],
    -70,
    [
      7797, 124, 2241, 124, 2016, 123, 1, 1, 1, 1, 2, 24176, 124, 91, 124, 91,
      124, 91, 124, 91, 124, 306, 124, 941, 123, 1, 1, 1, 1, 2,
    ],
    -60,
    [
      108, 7042, 4099, 18, 2, 32, 71, 1, 1, 1, 18, 282, 20, 99, 1, 1, 1, 1, 1,
      20, 1, 1, 1, 36, 46, 73, 1, 1, 1, 1, 1, 45, 1, 1, 1, 1, 2, 5609, 2, 5874,
      34, 9183, 215, 215, 215, 215, 215,
    ],
    -50,
    [
      7134, 14, 124, 1, 1, 1, 2863, 21, 1, 1, 96, 1, 1, 1, 1, 1, 542, 3, 124,
      497, 119, 1, 1, 1, 1, 1, 97, 8, 22, 101, 1, 1, 1, 1, 2, 16, 1, 1, 1, 476,
      1, 20437, 14, 124, 1, 1, 1, 74, 14, 124, 1, 1, 1, 74, 14, 124, 1, 1, 1,
      74, 14, 124, 1, 1, 1, 74, 14, 124, 1, 1, 1, 74, 14, 124, 1, 1, 1, 2648,
      21, 1, 1, 96, 1, 1, 1, 1, 1, 91, 21, 1, 1, 96, 1, 1, 1, 1, 1, 91, 21, 1,
      1, 96, 1, 1, 1, 1, 1, 91, 21, 1, 1, 96, 1, 1, 1, 1, 1, 91, 21, 1, 1, 96,
      1, 1, 1, 1, 1, 306, 21, 1, 1, 96, 1, 1, 1, 1, 1, 91, 119, 1, 1, 1, 1, 1,
      91, 119, 1, 1, 1, 1, 1, 91, 119, 1, 1, 1, 1, 1, 91, 119, 1, 1, 1, 1, 1,
      84, 1,
    ],
    -46,
    [23328, 216],
    -45,
    [11910, 124, 1, 1, 1],
    -40,
    [
      2580, 430, 2580, 215, 1325, 12, 2, 37, 73, 11, 1, 1, 1, 1, 2, 502, 21, 1,
      97, 1, 1, 1, 1, 1, 1437, 32, 92, 659, 2, 38, 242, 123, 1, 1, 1, 1, 2, 277,
      401, 1, 20, 123, 1, 1, 1, 1, 2, 280, 1, 201, 52, 119, 1, 1, 1, 1, 1, 4842,
      1861, 2, 4798, 9198, 12, 2, 37, 73, 11, 1, 1, 1, 1, 2, 74, 12, 2, 37, 73,
      11, 1, 1, 1, 1, 2, 74, 12, 2, 37, 73, 11, 1, 1, 1, 1, 2, 74, 12, 2, 37,
      73, 11, 1, 1, 1, 1, 2, 74, 12, 2, 37, 73, 11, 1, 1, 1, 1, 2, 74, 12, 2,
      37, 73, 11, 1, 1, 1, 1, 2, 2631, 2, 38, 175, 2, 38, 175, 2, 38, 175, 2,
      38, 175, 2, 38, 390, 2, 38, 5409,
    ],
    -35,
    [9324, 123, 1, 1, 1, 1, 2, 2441, 123, 1, 1, 1],
    -30,
    [
      7180, 2, 2, 32, 88, 1, 1, 1, 1, 35, 119, 1, 1, 1, 1, 1, 285, 2, 1538, 38,
      85, 1, 1, 1, 1, 2, 33, 1, 1, 1, 92, 32, 92, 712, 4, 115, 1, 1, 1, 1, 1, 3,
      1, 1, 1, 892, 2, 5235, 32, 92, 305, 1496, 123, 1, 1, 1, 1, 2, 502, 119, 1,
      1, 1, 1, 1, 6756, 119, 1, 1, 1, 1, 1, 6561, 2, 2, 32, 88, 1, 1, 1, 1, 87,
      2, 2, 32, 88, 1, 1, 1, 1, 87, 2, 2, 32, 88, 1, 1, 1, 1, 87, 2, 2, 32, 88,
      1, 1, 1, 1, 87, 2, 2, 32, 88, 1, 1, 1, 1, 87, 2, 2, 32, 88, 1, 1, 1, 1,
      4099, 2, 213, 2, 213, 2, 213, 2, 4804, 215, 215, 215, 215, 430, 1052, 119,
      1, 1, 1, 1, 1,
    ],
    -25,
    [
      19214, 123, 1, 1, 1, 1, 2, 6751, 123, 1, 1, 1, 1, 2, 19651, 123, 1, 1, 1,
      1, 2,
    ],
    -20,
    [
      8235, 119, 1, 1, 1, 1, 1, 683, 2, 19, 52, 67, 1, 1, 1, 1, 1, 52, 1, 1, 1,
      1555, 5, 1, 117, 1, 1, 1, 1, 2, 1, 1, 1, 1, 942, 42, 32, 49, 1, 1, 1, 1,
      2, 37, 2026, 32, 92, 87, 1, 3, 32, 88, 1, 1, 1, 1, 77, 1, 648, 123, 1, 1,
      1, 1, 2, 311, 32, 92, 947, 124, 1, 1, 1, 92, 32, 92, 88, 3, 32, 92, 445,
      54, 1, 11, 2, 110, 11, 1, 1, 1, 1, 2, 717, 119, 1, 1, 1, 1, 1, 105, 123,
      1, 1, 1, 1, 2, 4598, 10, 16128, 32, 92, 91, 32, 92, 91, 32, 92, 91, 32,
      92, 91, 32, 92, 91, 32, 92, 292, 1, 2163, 32, 92, 88, 3, 32, 92, 88, 3,
      32, 92, 88, 3, 32, 92, 88, 3, 32, 92, 88, 3, 32, 92, 303, 3, 32, 92,
    ],
    -15,
    [
      9314, 123, 1, 1, 1, 4621, 1, 644, 1, 2, 32, 92, 88, 1, 1, 1, 32, 92, 1156,
      123, 1, 1, 1, 1, 2, 94, 2, 32, 92, 519, 217, 32, 92, 288, 12, 34, 185,
      7310, 14404, 1, 214, 1, 214, 1, 214, 1, 214, 1, 214, 1, 644, 1, 1, 1, 32,
      92, 88, 1, 1, 1, 32, 92, 88, 1, 1, 1, 32, 92, 88, 1, 1, 1, 32, 92, 1379,
      215, 215, 215, 215, 430,
    ],
    -10,
    [
      7363, 124, 1, 1, 1, 3098, 124, 1, 1, 1, 1136, 1, 2194, 220, 211, 17, 32,
      92, 70, 374, 2, 55, 123, 1, 1, 1, 91, 1519, 124, 1, 1, 1, 2007, 123, 1, 1,
      1, 89, 123, 1, 1, 1, 6754, 123, 1, 1, 1, 13421, 215, 215, 215, 215, 215,
      431, 17, 32, 92, 2022, 124, 1, 1, 1, 2437, 123, 1, 1, 1,
    ],
    10,
    [
      14847, 487, 123, 1, 1, 1, 2256, 3, 32, 92, 1576, 123, 1, 1, 1, 6324, 123,
      1, 1, 1, 15297, 215, 215, 215,
    ],
    20,
    [10547, 2, 4300, 2865, 23580, 215, 215, 215],
    30,
    [15159, 2],
  ],
};
